import Lottie from "lottie-react";
import animatedGif from "../assets/Animation - 1707298499168.json";
import LoginForm from "../components/Login/LoginForm";
import Navbar from "../components/Login/Navbar";

const Login = () => {
  return (
    <div className="overflow-hidden h-full  ">
      <Navbar />
      <div className="lg:flex h-full lg:w-full md:items-end gap-[10%]">
        <div className="hidden  md:relative w-[22rem] lg:w-[40vw] h-[80vh] lg:flex md:justify-start md:items-start md:z-0 bg-bgGradientCustom" style={{ "border-radius": "0% 100% 100% 99% / 0% 97% 100% 93%  " }}>
          <div className="md:z-10 md:w-[80%] relative top-[8vh]  md:flex md:justify-end">
            <Lottie animationData={animatedGif} loop={true} style={{ width: '80%' }} />
          </div>
        </div>
        <div className="lg:hidden relative w-full">
          <img className="w-full sm:h-[380px] h-[340px]" src={require("../assets/Vector_login_og_02.png")} alt="" />
          <div className="absolute mb-10 bottom-0 left-0 w-full flex justify-center">
            <Lottie className="w-[50vw] sm:w-[300px]" animationData={animatedGif} loop={true} />
          </div>
        </div>
        <div className="flex relative lg:bottom-0 justify-center items-center">
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default Login;